import ParticleSystem from './ParticleSystem'

export default class KeyIndicator {
  private position: any
  private lifespan: number

  constructor(private p5: any, position: any) {
    this.position = position.copy()
    this.lifespan = 100
  }

  run() {
    this.update()
    this.display()
  }

  isDead(): boolean {
    return this.lifespan < 0
  }

  private update() {
    this.lifespan -= 10
  }

  private display() {
    const alpha = this.p5.constrain(this.p5.random(this.lifespan - 10, this.lifespan + 10) / 100, 0, 1)
    const color = this.p5.color(`rgba(255, 255, 255, ${alpha}`)
    const size = this.p5.random(20, 40)
    this.p5.fill(color)
    this.p5.ellipse(this.position.x, this.position.y, size, size)
  }
}

export const getKeyIndicator = (p: any, x: number, y: number): ParticleSystem => {
  const keyIndicator = new ParticleSystem(p, p.createVector(x, y), KeyIndicator)
  keyIndicator.addParticle()
  return keyIndicator
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/graphics/KeyIndicator.ts